
import { useEffect, useState } from "react";
import ApiService from "../../../services/ApiServiceClass";
import { useLoader } from "../../../hooks/useLoader";
import { RequestItemType } from "./RequestItemType";


export const useManageRequest = (requestID: number) => {
    const [requestItems, setRequestItems] = useState<RequestItemType[]>([]);
    const loader = useLoader();

    const fetchItems = async () => {

        try {
            const responseData = await ApiService.getItemsByRequestID(requestID);
            let itemData = [];
            if (responseData.data) {
                itemData = responseData.data.map((item: RequestItemType) => ({
                    request_id: item.request_id,
                    id: item.id,
                    name: item.name,
                    price: item.price,
                    price_nzd: item.price_nzd,
                    url: item.url,
                    currency: item.currency,
                    is_gst_included: item.is_gst_included,
                    supplier: item.supplier,
                    supplierPartNo: item.supplierPartNo,
                    with_quote: item.with_quote,
                    quote: item.quote
                }));
            }
            setRequestItems(itemData);
            return responseData;
        } catch (error) {
            throw (error);
        }
    }

    const handleDeleteItem = (itemID: number, setModal: (value: boolean) => void) => {
        loader?.setIsLoading(true);
        ApiService.deleteItemFromRequest(itemID)
            .then(() => {
                const newItemList:RequestItemType[] = requestItems.filter((item: RequestItemType) => item.id !== itemID);
                setRequestItems(newItemList)
                loader?.setIsLoading(false);
                setModal(false);
            })
            .catch((error) => {
                console.log(error);
                loader?.setIsLoading(false);
                setModal(false);                
            });        
    }

    const computeItemsTotalCosts = () => {
        const totalCosts = requestItems.reduce((accu: any, currentItem: any) => {
            const amount = accu + (currentItem.price_nzd);

            return amount;
        }, 0);
        
        return totalCosts;
    }

    const loadItems = async () => {
        try {
            loader?.setIsLoading(true);
            const itemsDO = await fetchItems();
            loader?.setIsLoading(false);
        } catch (error) {
            console.log(error);
            loader?.setIsLoading(false);
        }
    }

    useEffect(() => {        
       loadItems();
    },[]);
    return { requestItems, setRequestItems, handleDeleteItem, fetchItems, computeItemsTotalCosts };
}